import { render, staticRenderFns } from "./ComponentManageList.vue?vue&type=template&id=97d0d1a6&scoped=true&"
import script from "./ComponentManageList.vue?vue&type=script&lang=js&"
export * from "./ComponentManageList.vue?vue&type=script&lang=js&"
import style0 from "./ComponentManageList.vue?vue&type=style&index=0&id=97d0d1a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d0d1a6",
  null
  
)

export default component.exports